// react
import React, {useEffect, useState} from 'react';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';

// application
import {ArrowDown, Check9x7Svg} from '../../svg';
import {FormattedMessage} from 'react-intl';
import {useLocation} from "react-router-dom";

function FilterCheck(props) {
    const {
        data,
        value,
        onChangeValue,
        filterValues,
        code,
        groupedItems
    } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [seeAll, setSeeAll] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsOpen(false);
        setSeeAll(false);
    }, [location.search]);

    const handleChange = (event, itemCode) => {
        onChangeValue({
            filter: itemCode,
            value: event.target.checked
                ? [event.target.value]
                : event.target.value,
            remove: !event.target.checked
        });
    };

    const InitshowPerBlock = 4;

    const sourceItems = groupedItems && groupedItems.length
        ? groupedItems.reduce((result, group) => {
            (group.options || []).forEach(item => {
                result.push({
                    ...item,
                    filterCode: group.code,
                    uniqueKey: `${group.code}:${item.id}`
                });
            });

            return result;
        }, [])
        : (data || []).map(item => ({
            ...item,
            filterCode: code,
            uniqueKey: `${code}:${item.id}`
        }));

    const visibleItems = sourceItems.slice(
        0,
        sourceItems.length > InitshowPerBlock && !seeAll
            ? InitshowPerBlock
            : sourceItems.length
    );

    const itemsList = visibleItems.map((item) => {
        const itemClasses = classNames('filter-list__item', {
            'filter-list__item--disabled': item.count === 0,
        });

        const selectedValues = filterValues && filterValues[item.filterCode]
            ? filterValues[item.filterCode].toString().split(",")
            : [];

        return (
            <label key={item.uniqueKey} className={itemClasses}>
                <span className="filter-list__input input-check">
                    <span className="input-check__body">
                        <input
                            className="input-check__input"
                            type="checkbox"
                            value={item.id}
                            checked={selectedValues.includes(item.id.toString())}
                            disabled={item.count === 0}
                            onChange={(event) => handleChange(event, item.filterCode)}
                        />

                        <span className="input-check__box"/>
                        <Check9x7Svg className="input-check__icon"/>
                    </span>
                </span>

                <span className="filter-list__title">{item.label}</span>
            </label>
        );
    });

    return (
        <div className="filter-list">
            <div
                className="widget__title title-arrow-flex"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{props.title}</span>
                <ArrowDown className={isOpen ? "d-block rott_fms" : "d-block"}/>
            </div>

            <div className={isOpen ? "dropdown-group active filter-list__list" : "dropdown-group"}>
                {itemsList}

                {sourceItems.length > InitshowPerBlock ? (
                    <div className="see-all-block">
                        <span onClick={() => setSeeAll(!seeAll)}>
                            <FormattedMessage id="see_all" defaultMessage="See All ..."/>
                        </span>
                    </div>
                ) : ""}
            </div>
        </div>
    );
}

FilterCheck.propTypes = {
    data: PropTypes.array,
    value: PropTypes.object,
    onChangeValue: PropTypes.func,
    filterValues: PropTypes.object,
    code: PropTypes.string,
    groupedItems: PropTypes.array
};

export default FilterCheck;
